import { useState, useMemo, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSnackbar } from "notistack";
import Typography from "@material-ui/core/Typography";

// Form
import SmarthopForm from "@smarthop/form/SmarthopForm";
import { opsExceptionForm } from "@smarthop/form/configs/opsExceptionForm";

// Service
import { signInWithToken } from "app/services/LoginService";

// Utils
import { showSnackbar } from "app/main/utils/snackbarUtil";
import { incrementDataRevision } from "app/store/tools/revisionSlice";
import { setUserData } from "app/store/auth/userSlice";

/**
 * OpsExceptionView - Form dialog for creating/editing ops exceptions
 */
function OpsExceptionView(props) {
	const dispatch = useDispatch();
	const snackbar = useSnackbar();

	const hasSubaccounts = useSelector(({ auth }) => auth.account.subAccount?.hasSubaccounts);
	const user = useSelector(({ auth }) => auth.user);

	const native = window?.ReactNativeWebView ?? false;

	const dataIds = props?.dataIds;
	const onDone = props?.onDone;

	const mode = dataIds?.mode;
	const exceptionId = dataIds?.id;
	const historyData = dataIds?.historyData;
	const carrierOption = hasSubaccounts && dataIds?.carrierOption;

	const isCreate = mode === "CREATE";
	const carrierId = carrierOption ? null : dataIds?.carrierId;

	const [data, setData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [processing, setProcessing] = useState(false);
	const [error, setError] = useState(null);

	useEffect(() => {
		props?.setTitle?.(historyData ? "View Ops Exception" : isCreate ? "Add New Ops Exception" : "Edit Ops Exception");
		props?.setSize?.("max-w-xl");
		// eslint-disable-next-line
	}, []);

	const form = useMemo(() => opsExceptionForm({ user }), [user]);

	if (loading) {
		return (
			<div className="flex w-full h-512 flex-col items-center justify-center">
				<Typography color="primary" className="text-13 font-light mx-20 py-6 md:pb-48">
					Loading...
				</Typography>
			</div>
		);
	}

	if (error) {
		return (
			<div className="flex w-full h-512 flex-col items-center justify-center">
				<Typography className="w-full text-center" color="error">
					{error}
				</Typography>
			</div>
		);
	}

	return (
		<div className="mt-15">
			<SmarthopForm
				form={form}
				dataIds={{ ...dataIds, carrierId }}
				data={data}
				mode={historyData ? "COMPARE" : mode}
				onDone={() => {
					if (isCreate) {
						signInWithToken().then((userData) => {
							if (userData) dispatch(setUserData(userData, { skip_settings_set: true }));
						});
					}

					showSnackbar(snackbar, "Successfully Saved Exception", "success");

					dispatch(incrementDataRevision({ event: "profileRevision" }));
					dispatch(incrementDataRevision({ event: "opsExceptionRevision" }));
					dispatch(incrementDataRevision({ event: "dataRevision" }));
					if (native) window?.ReactNativeWebView?.postMessage(JSON.stringify({ type: "REFRESH_OPS_EXCEPTION_LIST" }));
					onDone?.();
				}}
				onProgress={(progress) => {
					setProcessing(progress);
				}}
			/>
		</div>
	);
}

export default OpsExceptionView;
